import * as React from 'react';
import { Input, Button } from 'antd';
import gql from 'graphql-tag';
import { ApolloClientFactory } from '../../domain/apolloClientFactory';

import FlashStore from '../../services/FlashStore';
import CountryService from '../../services/CountryService';
interface IProductAvailabilityEmailFormProps {
  afterSubmit?: () => void;
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
}

interface IProductAvailabilityEmailFormState {
  email?: string | null | undefined;
  emailValid: boolean;
  language: string;
}

class ProductAvailabilityEmailForm extends React.Component<
  IProductAvailabilityEmailFormProps,
  IProductAvailabilityEmailFormState
> {
  watchDogValidationTimeout: NodeJS.Timeout | null;
  constructor(props: IProductAvailabilityEmailFormProps) {
    super(props);
    this.handleButtonClick.bind(this);
    this.createWatchDog.bind(this);
    this.emailValidation.bind(this);
  }

  public componentDidMount() {
    this.getUser()
      .then(userInfo => {
        if (userInfo && (userInfo as any).data && (userInfo as any).data.userInfo) {
          if ((userInfo as any).data.userInfo.email) {
            this.setState({ email: (userInfo as any).data.userInfo.email });
            this.emailValidation();
          }
        }
      })
      .catch(e => console.log('Error getting user info', e));
  }

  public emailValidation() {
    const email = this.state.email || '';

    if (email && email.length > 3) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const testResult = re.test(String(email).toLowerCase());
      return this.setState({ emailValid: testResult });
    }
  }

  public render() {
    return this.renderForm();
  }

  private renderForm() {
    return (
      <div className="product-availability-watchdog-email-form">
        <div className="text">Enter your e-mail and we will let you know when this product is available.</div>
        <div className="email-input-wrapper">
          {/* {!this.state?.emailValid && <span className='error-label'>
            Please chceck if the e-mail is correct.
          </span>} */}
          <Input
            type="email"
            placeholder="your@email.com"
            onChange={(e: any) => {
              this.setState({ email: e.target.value }, this.emailValidation);
            }}
            value={this.state && this.state.email ? this.state.email : undefined}
          />
          <Button
            onClick={(e: any) => this.handleButtonClick()}
            className="btn"
            disabled={this.state && !this.state.emailValid}
          >
            Set watchdog
          </Button>
        </div>
      </div>
    );
  }

  private handleButtonClick() {
    if (!this.state || !this.state.email || !this.state.emailValid) {
      FlashStore.GetInstance().showMessage('You did not enter an email', 'error');
      return;
    }

    const language = CountryService.GetInstance().language;

    this.createWatchDog()
      .then(result => {
        FlashStore.GetInstance().showMessage(
          `When the product ${(this.props.product && this.props.product.name[language]) ||
            ''} is available, we will inform you to email ${this.state.email}`,
          'success',
        );
        if (this.props.afterSubmit) {
          this.props.afterSubmit();
        }
      })
      .catch(e => {
        console.log('ERROR: ', e);
      });

    return;
  }

  private async createWatchDog() {
    if (!this.state || !this.state.email) {
      return false;
    }

    const client = ApolloClientFactory.GetClient();

    const CreateWatchDog = gql`
      mutation($email: String!, $productId: String!, $variantId: String!, $countryId: String!) {
        createProductAvailabilityWatchDog(
          email: $email
          productId: $productId
          variantId: $variantId
          countryId: $countryId
        )
      }
    `;

    const response = await client.mutate({
      mutation: CreateWatchDog,
      variables: {
        email: this.state.email,
        productId: (this.props.product && this.props.product.id) || undefined,
        variantId: (this.props.variant && this.props.variant.id) || undefined,
        countryId: CountryService.GetInstance().countryId,
      },
      update: (storage, result) => {
        /* */
      },
    });

    return null;
  }

  private async getUser() {
    const client = ApolloClientFactory.GetClient();

    const query = gql`
      query UserInfo {
        userInfo {
          email
        }
      }
    `;

    const response = await client.query({
      query,
      fetchPolicy: 'network-only',
    });

    return response;
  }
}

export default ProductAvailabilityEmailForm;



// WEBPACK FOOTER //
// ./src/components/ProductAvailabilityEmailForm/ProductAvailabilityEmailForm.tsx